import * as React from 'react';

import styled from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';

interface Props {
  categories: Array<any | { name: string; url: string }>;
}

export default class CategoryChain extends React.Component<Props> {
  render() {
    const { categories } = this.props;
    return (
      <CategoryChainStyle>
        <Link to="/">
          <HouseImg src={'/images/home.svg'} />
        </Link>

        {categories &&
          categories.map((category: any, i) => {
            if (!category.name) {
              category.name = category.category_name;
            }

            return (
              <span key={i}>
                <Slash />
                <Link
                  style={{ textDecoration: 'none' }}
                  to={this.withLeadingSlash(category.url)}
                >
                  <CategoryName>{category.name}</CategoryName>{' '}
                </Link>
              </span>
            );
          })}
      </CategoryChainStyle>
    );
  }

  private withLeadingSlash = url => {
    if (url.startsWith('/')) {
      return url;
    }

    return '/' + url;
  };
}

class Slash extends React.Component {
  public render() {
    return <SlashStype> / </SlashStype>;
  }
}

const CategoryName = styled.span`
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-family: ${({ theme }) => theme.primaryFont || theme.fonts.primaryFont};
  color: ${({ theme }) => theme.colors.inactiveFontColor || `#aaaaaa`};
`;

const SlashStype = styled.span`
  margin-left: ${rem(8)};
  margin-right: ${rem(8)};
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-family: ${({ theme }) => theme.primaryFont || theme.fonts.primaryFont};
  color: ${({ theme }) => theme.colors.inactiveFontColor || `#aaaaaa`};
`;

const CategoryChainStyle = styled.div`
  margin-top: ${rem(30)};
`;

const HouseImg = styled.img`
  cursor: pointer;
  width: ${rem(15)};
  height: auto;
`;
